type UploadProvider = {
  id: string;
  siteID?: string | null;
  sites?: { id: string }[] | null;
};

const providerMatchesSite = (provider: UploadProvider, siteID: string) =>
  provider.siteID === siteID ||
  provider.sites?.some((site) => site.id === siteID) ||
  false;

export const resolveCurrentUploadProviderID = ({
  providerID,
  providers,
  siteID,
}: {
  providerID?: string | null;
  providers?: UploadProvider[] | null;
  siteID?: string | null;
}) => {
  const siteProvider =
    siteID && providers?.length
      ? providers.find((provider) => providerMatchesSite(provider, siteID))
      : null;

  return siteProvider?.id ?? providerID ?? null;
};
